export default __webpack_public_path__ + "static/media/Facebook.950802ad.png";